import {
  API,
  fetcher,
  Pagination,
  PaginationResponse,
} from "@/shared/core-configs";
import { Voucher } from "../types/Voucher";
import { useQuery } from "@tanstack/react-query";
import qr from "query-string";

export const GET_VOUCHERS_KEY = "@CORE_VOUCHERS_GET_VOUCHERS";

export type VoucherStateName = "Pendiente" | "Validado";

export type VoucherFilters = {
  showDisabled?: boolean;
  searchTerm?: string;
  zoneId?: string;
  state?: VoucherStateName;
  dateFrom?: string;
  dateTo?: string;
  productApplicantId?: string;
  costCenterId?: string;
  workOrderId?: string;
};

type GetVouchersParams = VoucherFilters & {
  sort?: string;
  order?: string;
} & Partial<Pagination>;

export const getVouchers = async ({
  page = 1,
  pageSize = 10,
  ...params
}: GetVouchersParams) => {
  const query = qr.stringify({ page, pageSize, ...params });
  const response = await fetcher.get(`${API.GESLUB_SERVICE}/voucher?${query}`);
  return response.data;
};

export const useGetVouchers = (params: GetVouchersParams) => {
  const { data, isPending, error } = useQuery<
    PaginationResponse<Voucher>,
    Error
  >({
    placeholderData: (previousData) => previousData,
    queryKey: [GET_VOUCHERS_KEY, params],
    queryFn: () => getVouchers(params),
  });

  return {
    data: data?.data || [],
    pagination: data?.pagination,
    isPending,
    error,
  };
};
